var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-center"},[_c('img',{attrs:{"src":"/assets/smartcat/data_is_empty.png","width":"500"}}),_c('p',[_c('b',[_vm._v("Data is Empty")])])])])
}]

export { render, staticRenderFns }